export const scheduleSchemaId = "MeetingsSchedule";
export const scheduleSlotSchemaId = "MeetingsScheduleSlot";